import React from 'react';
import styles from '../../../assets/css/vendors/steps_vendor.module.css';
// import CardPeoples from '../../../components/cards/CardPeoples';
import images from '../../../assets/images';
import Button from '../../../components/button/Button';
import next from '../../../assets/img/next.svg';
import { useNavigate } from 'react-router-dom';

function WarningVendor() {
    const navigation = useNavigate();
    return (
        <>
            <>
                <div className={`${styles.cardContent}`}>
                    <div className={styles.rectangle_grey}></div>
                    <div>
                        <div className={`${styles.cardSubContent}`}>
                            <div className={styles.circle_border}>
                                <img
                                    src={images.campfireSocialLogo}
                                    alt="Icon"
                                />
                            </div>
                            <br />
                            <br />
                            <h4 style={{ fontWeight: 600 }}>
                                Explore Providers
                            </h4>
                            <br />
                        </div>
                    </div>
                </div>
            </>
            <>
                <div className={`${styles.cardMainContent}`}>
                    <p>Explore Providers</p>
                    <p className={styles.note}>
                        Are you the company admin? Start building your company’s
                        profile now.
                    </p>
                    <div className={styles.container}>
                        <Button
                            text={'Create profile'}
                            classs={'btnMain'}
                            alignImg="right"
                            icon={next}
                            customStyle={{ width: 'auto' }}
                            onClick={() => navigation('/create-vendor')}
                        />
                    </div>
                </div>
            </>
        </>
    );
}
export default WarningVendor;
